import FrameBuffer from "_src/engine/framebuffer";
import primitiveFactory from "_src/engine/factories/primitive";
import objFactory from "_src/engine/factories/object";
import {primitiveType, blendFactor} from "_src/engine/constants";

import Pass from "_src/render_graph/pass";
import CopyShader from "_src/shaders/copy/copy";
import Camera from "_src/engine/camera";

export default class ResolvePass extends Pass {

  constructor() {

    super(null);

    this.init();

  }

  init() {

    this.shader = new CopyShader({transparent : true});
    this.shader.setSourceBlendFactor(blendFactor.ONE);

    this.screenFB = new FrameBuffer(null, null);

  }

  update(graphsData) {

    this.scenes.length = 0;

    for (let graphData of graphsData) {
      const screenCamera = new Camera();
      screenCamera.setViewport(graphData.viewport[2], graphData.viewport[3], graphData.viewport[0], graphData.viewport[1]);
      const scene = this._addScene(screenCamera);
      scene.clearedStencil = false;
      scene.clearedColor = this.scenes.length === 1;
      scene.clearedDepth = this.scenes.length === 1;

      scene.setFramebuffer(this.screenFB);

      const screenPlane = objFactory.createDrawable(this.shader);
      screenPlane.addGeometryChunk(primitiveFactory.create(primitiveType.SCREEN_QUAD));
      scene.add(screenPlane);

      screenPlane.setTexture(graphData.colorTexture, 0);
    }

  }

}
